import React, { useEffect, useRef } from 'react'
import './banner-component.scss'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { WarningIcon, SuccessIcon, ErrorIcon } from '../Icon'
import { RootState } from '../../../store'
import { hideBanner, showBannerTimeout } from '../../../global-state/banner-slice'
import { AnyAction } from '@reduxjs/toolkit'

const PermissionDeniedIcon = () => (
  <svg
    className='permission-denied-banner__icon'
    width={22}
    height={22}
    viewBox='0 0 22 22'
    aria-hidden
  >
    <circle cx='11' cy='11' r='10' fill='currentColor' />
    <rect x='5' y='10' width='12' height='2' rx='1' fill='#ffffff' />
  </svg>
)

const Banner = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const prevPathRef = useRef<string | null>(null)
  const { show, text, variant } = useSelector((state: RootState) => state.banner)

  useEffect(() => {
    if (show) {
      dispatch(showBannerTimeout() as unknown as AnyAction)
    }
  }, [dispatch, show, variant])

  useEffect(() => {
    const prev = prevPathRef.current
    prevPathRef.current = location.pathname
    if (prev === null || prev === location.pathname) {
      return
    }
    if (show && variant === 'permission-denied-banner') {
      dispatch(hideBanner())
    }
  }, [dispatch, location.pathname, show, variant])

  return (
    <>
      {show && (
        <div className={`banner-container ${variant}`} role='alert'>
          {variant === 'warning-banner' && <WarningIcon type={variant} />}
          {variant === 'success-banner' && <SuccessIcon />}
          {variant === 'error-banner' && <ErrorIcon />}
          {variant === 'permission-denied-banner' && <PermissionDeniedIcon />}
          <span>{text}</span>
        </div>
      )}
    </>
  )
}

export { Banner }
